import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";
import { ProtectedRoute, AdminRoute, GuestRoute } from "@/components/RouteGuards";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import HistoryPage from "@/pages/HistoryPage";
import TermDetailPage from "@/pages/TermDetailPage";
import NotesPage from "@/pages/NotesPage";
import StatsPage from "@/pages/StatsPage";
import PreferencesPage from "@/pages/PreferencesPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPage from "@/pages/PrivacyPage";
import SupportPage from "@/pages/SupportPage";

import AdminLayout from "@/components/AdminLayout";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import AdminTermsPage from "@/pages/admin/AdminTermsPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
      <Route path="/register" element={<GuestRoute><RegisterPage /></GuestRoute>} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/support" element={<SupportPage />} />

      {/* Public shell — Home is the landing page for everyone (signed-in or not) */}
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
      </Route>

      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/library" element={<HistoryPage />} />
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/term/:id" element={<TermDetailPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/preferences" element={<PreferencesPage />} />
      </Route>

      <Route element={<AdminRoute><AdminLayout /></AdminRoute>}>
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/terms" element={<AdminTermsPage />} />
        <Route path="/admin/settings" element={<AdminSettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
